import { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import {Box, Card, CardContent, Divider, Link, Chip, Stack} from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { SearchDocument } from '../../../types/search/searchDocument';

interface Props {
    documents: SearchDocument[];
}

const FormList = (props:Props): JSX.Element => {

    const [documentList, setDocumentList] = useState<SearchDocument[]>([]);
    const [toggleViewMore, setToggleViewMore] = useState(false);

    useEffect(() => {
      setDocumentList(props.documents.slice(0,3));
      setToggleViewMore(props.documents.length > 3? true: false);
    }, [props.documents]);

    const handleViewMore = () => {
      setToggleViewMore(!toggleViewMore);
      setDocumentList(props.documents);
   }

  return (
    <Box>
        <Typography
            variant="h6"
            align={'left'}
            sx={{
            fontWeight: 700,
            }}
            color={'secondary'}
            paddingTop={3}
            gutterBottom
        >
        Forms
        </Typography>
        <Divider textAlign="right">
            <Typography component={'i'} variant='body2' color="primary">{props.documents.length} total result(s)</Typography>
        </Divider>
        <Grid container marginTop={3}>
          {documentList.map((document) => (
            <Grid size={{xs:12, md:10}} key={document.id} marginBottom={2}>
              <Box
                component={Card}
                variant={'outlined'}
                bgcolor={'transparent'}
                sx={{
                  cursor: 'pointer',
                  '&:hover': {
                  boxShadow: 2,
                },
                }}
              >
                <CardContent>
                  <Chip label={"OCPF Form"} size="small" sx={{fontSize: "0.75rem"}} />
                  <Stack 
                    marginTop={1}
                    direction={'column'}
                    spacing={1}
                    alignItems={"left"}
                  >
                    <Typography fontWeight={550} variant='subtitle1'>{document.title}</Typography>
                    <Typography variant='subtitle2' color="text.secondary"><span dangerouslySetInnerHTML={{ __html: document.description }} /></Typography>         
                  </Stack>
                  <Stack direction={'row'} spacing={1} alignItems={"left"} marginTop={1}>
                    <PictureAsPdfIcon />
                    <Typography component={Link} variant='subtitle2' href={document.url} target='_blank' marginLeft={1} fontWeight={550}>
                        Download Form
                    </Typography>
                  </Stack>
                </CardContent>
              </Box>
            </Grid>
          ))}
          {
            toggleViewMore && 
            <Grid size={10} display="flex" justifyContent="flex-end" marginTop={1}>
              <Link className='is-clickable' onClick={handleViewMore} underline='hover' fontSize={"small"}  component={"i"}><i>View More Results</i></Link>
            </Grid>
          }
        </Grid>
  </Box>
  );
};

export default FormList;